import React from 'react';
import {
  MapPin,
  Briefcase,
  Clock,
  CalendarCheck,
  Scale
} from 'lucide-react';
import TimedPill from './TimedPill';
import PillList  from './PillList';
import InfoRow   from './InfoRow';
import { formatPay, computeAvailability } from './utils';
import CertificationBadge from './CertificationBadge';
import SRNABadge from './SRNABadge';

const ProfileFront = ({ p = {} }) => {
  // Better defaults for when properties are undefined or null
  const {
    role = 'CRNA',
    crnaCertificationStatus = 'No',
    locationPreference = 'N/A',
    radiusPreference   = '—',
    desiredWorkType    = [],
    yearsOfExperience  = '—',
    compensation = {},
    availability = {}
  } = p || {};
  
  // Safely extract nested properties with proper defaults
  const { type: compType = 'hourly', amount: compAmt = 0 } = compensation || {};
  const { 
    contractType = [], 
    desiredSchedule = [], 
    availabilityDate = new Date().toISOString() 
  } = availability || {};

  return (
    <div className="card-face-content" role="region" aria-label="Profile Front">
      <div className="card-header">
        <h2 className="card-title">{role}</h2>
       {crnaCertificationStatus === 'Yes' && <CertificationBadge />}
       {crnaCertificationStatus === 'SRNA' && <SRNABadge />}
      </div>

      <InfoRow Icon={Scale}>
        <div className="pay-contract-details">
          <TimedPill
            id="pay-rate"
            label={formatPay(compType, compAmt)}
            tooltipText={`Compensation: ${compType || 'hourly'} at ${formatPay(compType, compAmt)}`}
          />
          <PillList
            items={Array.isArray(contractType) && contractType.length > 0 ? contractType : ['—']}
            getTooltip={() => 'W2 = employed; 1099 = contract'}
            idPrefix="contract"
          />
        </div>
      </InfoRow>

      <InfoRow Icon={CalendarCheck}>
        <PillList
          items={[computeAvailability(availabilityDate)]}
          getTooltip={() => 'Earliest available date'}
          idPrefix="availability"
        />
      </InfoRow>

      <InfoRow Icon={MapPin}>
        <PillList
          items={[`${locationPreference} (${radiusPreference} mi)`]}
          getTooltip={() => 'Preferred location and commute distance'}
          idPrefix="location"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={Briefcase}>
        <PillList
          items={Array.isArray(desiredWorkType) && desiredWorkType.length > 0 ? desiredWorkType : ['—']}
          getTooltip={it => it === '—' ? 'No work type specified' : `Preferred work type: ${it}`}
          idPrefix="workType"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={Clock}>
        <PillList
          items={[`${yearsOfExperience} yrs`]}
          getTooltip={() => `${yearsOfExperience} years of CRNA experience`}
          idPrefix="experience"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={CalendarCheck}>
        <PillList
          items={Array.isArray(desiredSchedule) && desiredSchedule.length > 0 ? desiredSchedule : ['—']}
          getTooltip={it => it === '—' ? 'No schedule preference specified' : `Schedule preference: ${it}`}
          idPrefix="schedule"
        />
      </InfoRow>
    </div>
  );
};

export default ProfileFront;
